import React, { Fragment } from "react";
import Titre from "../../../components/UI/Titres/TitreH1";
import Image from 'react-bootstrap/Image';
import imgAccueil from "../../../assets/images/chateau.jpg";

const  accueil = (props) => (
    <Fragment>
         <Titre>Bienvenue sur le site des établissements publics en France !</Titre>
         <p></p>
         <Image src={imgAccueil} fluid thumbnail style={{width:"100%"}}/>
    </Fragment>
);
export default accueil;